import styled from "styled-components";

const MenuStyle: any = styled.div`
  .drawer > div {
    padding: 24px 0 24px 24px;
    border-right: none;
    background-color: transparent;
  }

  .icon-drawer--variant {
    &:hover {
      cursor: pointer;
    }
  }

  .icon-drawer--variant {
    box-sizing: border-box;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: ${(props: any) =>
      props.open ? "space-between" : "center"};
    padding: ${(props: any) => (props.open ? "16px 12px 16px 24px" : "16px 0")};
    border-bottom: 1px solid ${(p) => p.theme.palette.primary.light};
    color: ${(p) => p.theme.palette.primary.contrastText};

    .fa-icon {
      font-size: 24px;
    }
  }

  .open-drawer,
  .close-drawer {
    height: 100%;
    overflow-x: hidden;
    white-space: nowrap;
    -webkit-transition: width 0.5s;
    transition: width 0.5s;
    background-color: ${(p) => p.theme.palette.primary.main};
    border-radius: 4px;
  }

  .close-drawer {
    width: 72px;
  }

  .open-drawer {
    width: 264px;
  }

  .faBtn {
    min-width: 36px;
    min-height: 36px;
    background-color: transparent;
    color: ${(p) => p.theme.palette.primary.contrastText};
    border: none;
    border-radius: 0;
    padding: 0;
    cursor: pointer;
    &:hover {
      background-color: ${(props) => props.theme.opacityMask4};
    }
  }
`;

export default MenuStyle;
